module.exports = __webpack_public_path__ + "media/images/oak/slides/slide-2-mobile-f57567de2905413738c41d7bd2334d5c.jpg";